import React from 'react';
import type { TipData } from '../types';

interface TipItemProps {
  data: TipData;
  currentLang: string;
  t: (key: string, lang: string) => string;
}

const TipItem: React.FC<TipItemProps> = ({ data, currentLang, t }) => {
  const textKey = `tips.${data.key}`;
  
  // Extrai o nome do arquivo do imageRef e constrói o caminho correto
  const imageName = data.imageRef.split('/').pop();
  const imagePath = `/img/${imageName}`;

  return (
    <div className="flex-items">
      {imageName && (
        <div className="tip-image">
          <img 
            src={imagePath} 
            alt={t(textKey, currentLang)} 
            className="tip-gif"
          />
        </div>
      )}
      
      <div className="tip-text-wrapper">
        <p className="tip-text">
          {t(textKey, currentLang)}
        </p>
      </div>
    </div>
  );
};

export default TipItem;
